module.exports = __webpack_public_path__ + "media/images/brand/logo-05-51162a29c0e1b5052305625242c8abac.png";